import "requestidlecallback-polyfill"
import type { App } from "vue"

import { scrollbarDirective } from "@peerup/helper"
import { createSuiteAdapter, SuiteAdapter } from "@peerup/suite/adapter"
import { createApp } from "vue"

import { setupAntd, setupI18n } from "@/plugins"
import { setupStore } from "@/store"

import AppVue from "./App.vue"

// import MicroApp from "./MicroApp.vue"
import "ant-design-vue/dist/reset.css"

import "./style/style.less"
import { isDebugger } from "./config"
// import "virtual:svg-icons-register"
import { setupRouter } from "./router"
import { cleanSentryContext, setupVueSentry } from "./sentry"

const createAccountsApp = () => {
  const app = createApp(AppVue)
  return app
}
async function setupPlugins(app: App) {
  setupAntd()
  // 注册i18n
  await setupI18n(app)
  // 挂载vuex状态管理
  setupStore(app)
  return app
}

async function setupApp(app: App) {
  app.use(scrollbarDirective)
  await setupRouter(app)
  app.mount("#accounts-app")
}

let suiteAdapter: SuiteAdapter | null = null

if (SuiteAdapter.isMicroApp()) {
  let app: App | null = null
  suiteAdapter = createSuiteAdapter({
    mount: async () => {
      if (app) return
      import("./utils/logger").then(({ default: $logger }) => {
        $logger.log("[accounts]初始化前端应用")
      })
      app = createAccountsApp()
      app.config.globalProperties.$suiteAdapter = suiteAdapter
      document.body.classList.add("micro-app-body")
      // 全局挂载suite
      await setupPlugins(app)
      setupVueSentry(app)
      await setupApp(app)
    },
    unmount: () => {
      if (!app) return
      app.unmount()
      cleanSentryContext()
      app = null
    },
  })
  suiteAdapter.bootstrap()
} else {
  // 普通应用，非微应用
  const app = createAccountsApp()
  setupPlugins(app).then(() => {
    setupApp(app)
  })
  import("./utils/logger").then(({ default: $logger }) => {
    $logger.log("[accounts]初始化前端应用")
  })

  if (isDebugger()) {
  // 开发环境提示离开页面, 方便调试
    window.onbeforeunload = () => {
      return true
    }
  }
}

// export { suiteAdapter }
